exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-5da32885] .ButtonContainer.PictureUpload > span.Button {\n    line-height: 36px;\n    padding-top: 0px;\n}\n[data-v-5da32885] .ButtonContainer.PictureUpload input.file {\n    line-height: 36px;\n}\n", ""]);

// exports
